import React from "react";

const ExtrasInfo = (props) => {
  return (
    <div className="card">
      <h3>Extracurricular</h3>
      <div className="card-body">
        {props.data?.uncommonNewData?.extraOne && (
          <div class="datas">
            <p>Extracurricular One:</p>
            <del>{props.data?.uncommonOldData?.extraOne}</del>
            <span>{props.data?.uncommonNewData?.extraOne}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.extraTwo && (
          <div class="datas">
            <p>Extracurricular Two:</p>
            <del>{props.data?.uncommonOldData?.extraTwo}</del>
            <span>{props.data?.uncommonNewData?.extraTwo}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.extraThree && (
          <div class="datas">
            <p>Extracurricular Three:</p>
            <del>{props.data?.uncommonOldData?.extraThree}</del>
            <span>{props.data?.uncommonNewData?.extraThree}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.extraFour && (
          <div class="datas">
            <p>Extracurricular Four:</p>
            <del>{props.data?.uncommonOldData?.extraFour}</del>
            <span>{props.data?.uncommonNewData?.extraFour}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.extraFive && (
          <div class="datas">
            <p>Extracurricular Five:</p>
            <del>{props.data?.uncommonOldData?.extraFive}</del>
            <span>{props.data?.uncommonNewData?.extraFive}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExtrasInfo;
